import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {extractLastCardNumbers, getPayerDetailsBuilder} from "../../actions/InvoiceActions";
import {getPayerAccount, getSelectedPrimaryAccount, getSelectedSecondaryAccount} from "../invoice/Selectors";
import {deletePaymentMethod} from "../../requests/TokenRequests";
import {deleteSessionCard, deleteSessionCheck} from "../../reducers/PaymentReducer";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome/index.es";

export class PaymentTypeDetails extends Component {

  constructor() {
    super();
    this.displayText = this.displayText.bind(this);
    this.getIconImage = this.getIconImage.bind(this);
    this.deletePaymentCard = this.deletePaymentCard.bind(this);
  }

  displayText() {
    let p = this.props.payment_card;
    let digits = extractLastCardNumbers(p.payment_card_token);
    if (p.payment_card_type === 'EC') {
      return `eCheck ending with *${digits}`;
    } else {
      return `${p.payment_card_type} ending with *${digits}`;
    }
  }

  displayText2() {
    let p = this.props.payment_card;
    return `${p.payment_card_name}`;
  }

  getIconImage() {
    if (this.props.payment_card.payment_card_type === 'EC') {
      return <FontAwesomeIcon icon={"money-check"}/>
    } else {
      return <FontAwesomeIcon icon={"credit-card"}/>
    }
  }


  async deletePaymentCard() {
    this.props.deletePaymentMethod(this);
  }

  render() {
    return <div className={'payment-type-details mb-2'}>
      <div className={"payment-type-icon-container"}>
        <span>{this.getIconImage()}</span>
        {this.props.payment_card.isDefault ? <span className="p-0" title="Default"><FontAwesomeIcon icon={"asterisk"}/></span> : null}
      </div>
      <div className={"payment-type-description-container"}>
        <div>
          <span className="payment-card-description">{this.displayText2()}</span>
        </div>
        <div>
          <small className={"text-muted"}>
            <span className="payment-card-description">{this.displayText()}</span>
            {this.props.payment_card.is_session && <span> (Session)</span>}
          </small>
        </div>
      </div>
      <div className={"payment-type-actions"}>
        <span role={"button"} className={"font-button-icon"}
                data-bs-toggle="modal"
                data-bs-target={`#confirmDelete-${this.props.payment_card.payment_card_token}`}>
              <FontAwesomeIcon icon={"trash"}/> Delete</span>
        <span role={"button"} className={"font-button-icon"}
              onClick={() => {this.props.onEdit(this.props.payment_card)}}>
              <FontAwesomeIcon icon={"edit"}/> Edit</span>
      </div>
      
      <div
          className="modal fade"
          id={`confirmDelete-${this.props.payment_card.payment_card_token}`}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="confirmDeleteLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="confirmDeleteLabel">
                  Confirm Deletion
                </h5>
		            <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                Are you sure you want to delete your credit card from the payment method list?
              </div>
              <div className="modal-footer">
                        <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={this.deletePaymentCard}>
                  Ok
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>

    </div>
  }
}

PaymentTypeDetails.propTypes = {
  payment_card_index: PropTypes.number,
  payment_card: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default connect((state, props) => {
  return {
    payerAccount: getPayerAccount(state, props),
    primaryAccount: getSelectedPrimaryAccount(state, props),
    secondaryAccount: getSelectedSecondaryAccount(state, props),
    currentUser: state.default.currentUser,
  }
}, (dispatch) => {
  return {
    deletePaymentMethod: async (comp) => {
      if (comp.props.payment_card.is_session) {
        dispatch(deleteSessionCard(comp.props.payment_card, comp.props.payerAccount.PrimaryAcct));
        dispatch(deleteSessionCheck(comp.props.payment_card, comp.props.payerAccount.PrimaryAcct));
      } else {
        await deletePaymentMethod(comp.props.payerAccount.PrimaryAcct, comp.props.primaryAccount.CompanyCode, comp.props.payment_card);
        getPayerDetailsBuilder(dispatch, comp.props.primaryAccount, comp.props.secondaryAccount, comp.props.currentUser);
      }
      comp.props.onDelete(comp.props.payment_card);
    }
  }
})(PaymentTypeDetails);
